var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { of as observableOf } from 'rxjs';
import { filter, switchMap, map, tap } from 'rxjs/operators';
import { LoopBackAuth, MemberApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CAAction } from '../actions';
import * as actions from '../actions/index';
import { Router } from '@angular/router';
var STORAGE_ACTION = '[Storage] Value changed';
var AuthEffects = /** @class */ (function () {
    function AuthEffects(store, actions$, api, auth, router) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.api = api;
        this.auth = auth;
        this.router = router;
        this.getAuthLogin = this.actions$.ofType(actions.REQUEST_AUTH_LOGIN).pipe(switchMap(function (action) {
            return _this.api
                .customLogin(action.payload)
                .map(function (res) { return new actions.ResponseSuccessAuthLoginAction(res); })
                .catch(function (err) { return observableOf(new actions.ResponseFailAuthLoginAction(err)); });
        }));
        this.logoutIfNoOrganisations = this.actions$
            .ofType(actions.Organisations.NO_VALID_ORGANISATIONS)
            .pipe(map(function (action) { return new actions.RequestAuthLogoutAction(); }));
        this.redirectAfterReset = this.actions$.ofType(actions.RESPONSE_SUCCESS_AUTH_FORGOT_PASSWORD).pipe(tap(function () {
            _this.router.navigate(['/']);
        }));
        this.getAuthLogout = this.actions$.ofType(actions.REQUEST_AUTH_LOGOUT).pipe(switchMap(function (action) {
            return _this.api
                .logout()
                .map(function (res) { return new actions.ResponseSuccessAuthLogoutAction(); })
                .catch(function (err) { return observableOf(new actions.ResponseSuccessAuthLogoutAction()); });
        }));
        this.getAuthForgotPassword = this.actions$.ofType(actions.REQUEST_AUTH_FORGOT_PASSWORD).pipe(switchMap(function (action) {
            return _this.api
                .customResetPassword(action.payload)
                .map(function (res) { return new actions.ResponseSuccessAuthForgotPasswordAction(); })
                .catch(function (err) { return observableOf(new actions.ResponseFailAuthForgotPasswordAction(err)); });
        }));
        this.clearOnLogout = this.actions$
            .ofType(actions.RESPONSE_SUCCESS_AUTH_LOGOUT)
            .pipe(map(function (action) { return new actions.RequestStateReset(); }));
        this.redirectOnLogout = this.actions$
            .ofType(actions.RESPONSE_SUCCESS_AUTH_LOGOUT)
            .pipe(map(function () { return actions.NavigateAction({ path: ['/auth'] }); }));
        this.forceLogout = this.actions$
            .ofType(actions.FORCE_LOGOUT_401)
            .pipe(map(function (action) { return new actions.RequestAuthLogoutAction(); }));
        this.tabTokenChanges = this.actions$.ofType(STORAGE_ACTION).pipe(filter(function (action) { return action.payload.key === 'auth'; }), tap(function (action) { return _this.auth.setToken(action.payload.newValue.auth); }));
        window.addEventListener('storage', function (event) {
            var newValue, key;
            (key = event.key, newValue = event.newValue);
            try {
                newValue = JSON.parse(newValue);
            }
            catch (ex) {
                newValue = {};
            }
            _this.store.dispatch({ type: STORAGE_ACTION, payload: { key: key, newValue: newValue } });
        });
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "getAuthLogin", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "logoutIfNoOrganisations", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "redirectAfterReset", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "getAuthLogout", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "getAuthForgotPassword", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "clearOnLogout", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "redirectOnLogout", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "forceLogout", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], AuthEffects.prototype, "tabTokenChanges", void 0);
    return AuthEffects;
}());
export { AuthEffects };
